import { render, staticRenderFns } from "./more.vue?vue&type=template&id=c62cf1bc&scoped=true"
import script from "./more.vue?vue&type=script&lang=js"
export * from "./more.vue?vue&type=script&lang=js"
import style0 from "./more.vue?vue&type=style&index=0&id=c62cf1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62cf1bc",
  null
  
)

export default component.exports